module.exports = __webpack_public_path__ + "static/media/Slide41.cdd630eb.JPG";